import { UI, VStack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { SubscriptionSmallCardProps } from '..';
import { LateralBar } from '../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import { useSubscriptionDetailContext } from '../../../contexts/SubscriptionDetail';
import { SubscriptionInfo } from '../../SubscriptionCard/components/SubscriptionInfo';
import { SubscriptionMainInfo } from '../../SubscriptionCard/components/SubscriptionMainInfo';
import { SubscriptionTimeLimit } from '../../SubscriptionCard/components/SubscriptionTimeLimit';

export const SubscriptionSmallCardMobile: React.FC<SubscriptionSmallCardProps> = ({
  subscription,
}) => {
  const { setModalOpen, setSubscriptionSelected } = useSubscriptionDetailContext();

  const handleOpenItemDetailsModal = () => {
    setModalOpen(true);
    setSubscriptionSelected(subscription);
  };

  return (
    <UI.Shadow level={1} borderRadius={BoxBorder.heavy}>
      <Box p="inset.xs" w="full">
        <LateralBar
          backgroundColor="product.rendavariavel"
          borderTopLeftRadius="sm"
          borderBottomLeftRadius="sm"
        />
        <VStack justifyContent="space-between" space="stack.xxxs">
          <SubscriptionMainInfo
            description={`ISIN: ${subscription.baseIsinCode}`}
            title={subscription.productDisplay}
            onDetailsPress={handleOpenItemDetailsModal}
            hasLeftovers={subscription.hasLeftovers}
            isMobile
          />
          <SubscriptionInfo label="Data limite" value={subscription.limitDateFormatted} isMobile />
          <SubscriptionTimeLimit
            daysSinceDeadline={subscription.daysSinceDeadline}
            daysToDeadline={subscription.daysToSettlement}
            type={subscription.timeLimitType}
            isMobile
          />
          <SubscriptionInfo
            label="Clientes aptos"
            value={`${subscription.customersEligible}`}
            isMobile
          />
          <SubscriptionInfo
            label="Preço unitário"
            value={subscription.unitaryPriceFormatted}
            isMobile
          />
        </VStack>
      </Box>
    </UI.Shadow>
  );
};
